import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap5';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Alert from 'components/new_ui/Alerts/alert';
import Modal from 'components/new_ui/Modal/Modal';
import Table from 'components/new_ui/Table';
import { useContext as useMembersContext } from 'components/Managers/Members/Context';
import { useContext } from 'components/Managers/Programs/Context';

export default function MembersModal({ show, templateTitle, onCloseClick }) {
  const navigate = useNavigate();
  const { templateId } = useParams();
  const { state: stateMembers } = useMembersContext();
  const { actions, state } = useContext();
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      name: 'Name',
      selector: (row) => row.attributes.full_name,
      sortable: true,
    },
    {
      name: 'Work Email',
      selector: (row) => row.attributes.email,
      sortable: true,
    },
    {
      name: 'Team',
      selector: (row) => row.attributes.team,
      sortable: true,
    },
  ];

  const allMembers = stateMembers.members || [];
  const data = allMembers.filter((member) => state.selectedMembers.includes(member.id));

  const handleError = (message) => {
    onCloseClick();

    Alert({
      title: 'Assign Members',
      text: message,
      confirmButtonText: 'Close',
    });
  };

  const assignProgram = () => {
    setLoading(true);

    actions.assignProgram(
      {
        programId: templateId,
        memberIds: state.selectedMembers,
        afterCallback: (response) => {
          setLoading(false);

          if (response.data.status) {
            navigate(routes.managers.programs.success);
          } else {
            handleError(response.data.message);
          }
        },
      },
    );
  };

  return (
    <Modal show={show} size="lg">
      <Table
        title={`Assign Members - ${templateTitle}`}
        columns={columns}
        data={data}
        selectableRows={false}
      />

      <footer>
        <Button
          variant="outline-primary"
          onClick={onCloseClick}
        >
          Close
        </Button>

        <Button
          onClick={assignProgram}
          disabled={loading}
        >
          {loading && <LoadingPlaceholder placement="inline" />}
          {' '}
          Assign
        </Button>
      </footer>
    </Modal>
  );
}

MembersModal.propTypes = {
  show: PropTypes.bool.isRequired,
  templateTitle: PropTypes.string.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};
